import React from 'react';
import loadingSVG from '../../../../assets/images/spinner-DNA-2s-200px.svg';
import './Loading.scss';
function Loading() {
  return /*#__PURE__*/React.createElement("div", {
    className: "loading"
  }, /*#__PURE__*/React.createElement("img", {
    src: loadingSVG,
    alt: "Loading_image"
  }));
}
export default Loading;